import { faBell } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Col, Row } from "react-bootstrap";
import { IComplaintDetails } from "../../../api/IComplaint";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";

interface ComplaintDetailsProps {
  complaintDetails: IComplaintDetails;
}

const DataProtectionAlert = () => (
  <Alert variant={"secondary"} dismissible={false}>
    <div className="alert-icon">
      <FontAwesomeIcon icon={faBell} fixedWidth />
    </div>
    <div className="alert-message">
      Certain information has been withheld from this complaint record due to
      GDPR
    </div>
  </Alert>
);

const ComplaintDetails = ({ complaintDetails }: ComplaintDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Received by EPA"}
            value={complaintDetails.datereceived}
          />
          <EpaField
            label={"Date Occurred"}
            value={complaintDetails.dateoccurred}
          />
          <EpaField label={"Complaint Type"} value={complaintDetails.subject} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField label={"Date Closed"} value={complaintDetails.closeddate} />
          <EpaField
            label={"Duration"}
            value={complaintDetails.durationofoccurance}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12" style={{ marginTop: "20px" }}>
          <DataProtectionAlert />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Complaint Details"} content={bodyElements} />;
};

export default ComplaintDetails;
